import { useState } from 'react';

export default function useInputValue(initialValue = '') {
  const [value, setValue] = useState(initialValue);
  const handleChange = (event) => setValue(event.target.value);

  return [value, handleChange];
}
